export default __webpack_public_path__ + "static/media/Logos.60347202.svg";